import React, { memo, useState, useEffect } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { GetProcessedFile, GetUnderProcessFile, GetErrorFile, GetPartiallyUpdated } from './ExportHistoryFileType';
import { getListingData } from '../../../actions/products';

function getFileStatus(itemData) {
  switch (itemData.action) {
    case 'EXPORT': {
      function status(status) {
        switch (status) {
          case 'FILE_GENERATED':
            return <GetProcessedFile data={itemData} />;

          case 'GENERATING_FILE':
            return <GetUnderProcessFile data={itemData} />

          case 'PARTIALLY_COMPLETED':
            return <GetPartiallyUpdated data={itemData} />

          case 'EXPORT_FAILED':
            return <GetErrorFile data={itemData} />

          default:
            return null;
        }
      }
      return status(itemData.status)
    }

    case 'IMPORT': {
      function status(status) {
        switch (status) {
          case 'COMPLETED':
            return <GetProcessedFile data={itemData} />;

          case 'FILE_GENERATED':
            return <GetProcessedFile data={itemData} />;

          case 'UPDATING':
            return <GetUnderProcessFile data={itemData} />;

          case 'GENERATING_FILE':
            return <GetUnderProcessFile data={itemData} />;

          case 'PARTIALLY_COMPLETED':
            return <GetPartiallyUpdated data={itemData} />

          case 'UPDATE_FAILED':
            return <GetErrorFile data={itemData} />

          default:
            return null;
        }
      }
      return status(itemData.status)
    }
    default:
      return null;
  }
}

function ImportExportFileProgress(props) {
  const { item, activeTab } = props;
  const [itemState, setitemState] = useState(() => item);
  const dispatch = useDispatch();

  useEffect(() => {
    if (itemState.completionPercentage < 100 && (itemState.status === 'GENERATING_FILE' || itemState.status === 'UPDATING')) {
      let params = {
        jobType: itemState.action === 'EXPORT' ? 'PRODUCT_EXPORT' : 'PRODUCT_IMPORT',
        jobId: itemState.id
      }
      setTimeout(() => {
        axios.get('/marketplace/progress/ajax/service/getProgress.service', { params })
          .then(({ data }) => {
            if (data.jobStatus === 'FILE_GENERATED' || data.jobStatus === 'COMPLETED') {
              dispatch(getListingData({ tabKey: activeTab }));
            }
            setitemState(() => ({ ...itemState, completionPercentage: data?.completionPercentage, status: data.jobStatus, totalCount: data.totalCount || data.totalUnits }))
          });
      }, 4000)
    }
  }, [itemState]);

  return (
    <div>
      {getFileStatus(itemState)}
    </div>
  );
};

export default memo(ImportExportFileProgress);